<template>
  <div
    id="main-wrapper"
    class="flex flex-col items-center pt-8"
    v-if="!isLoading"
    :style="{
      backgroundColor: hasErrors ? '#ffcccc' : colorBackground,
    }"
  >
    <vs-row v-if="logoUrl" vs-justify="center" class="mb-8">
      <img height="192" :src="logoUrl" />
    </vs-row>

    <vx-card class="max-w-xl my-8 mx-2">
      <div v-if="hasErrors" class="text-center">
        Cannot find a document for the specified venue.
      </div>
      <div v-else v-html="documentHtml"></div>
    </vx-card>
  </div>
</template>


<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      isLoading: true,
      hasErrors: false,

      // Inputs
      venueId: null,
      docId: null,

      // Outputs from function call
      documentHtml: null,
      logoUrl: null,
      colorBackground: "#fff",
      colorFont: "#000",

      apiConfig: {
        legalDocumentUrl: (venueid, docid) =>
          `https://rekom-crm-functions-prod.azurewebsites.net/api/DynamicFormsGetLegalDocument?venueid=${venueid}&docid=${docid}`,
      },
    };
  },

  async created() {
    this.isLoading = true;
    this.venueId = this.$route.query.venueId;
    this.docId = this.$route.query.docId;

    if (!this.venueId || !this.docId) {
      this.hasErrors = true;
      this.isLoading = false;
      return;
    }

    try {
      const url = this.apiConfig.legalDocumentUrl(this.venueId, this.docId);
      const result = await fetch(url);
      const json = await result.json();

      console.log("Json", json);
      // this.documentHtml = json.doc.documentHtml;
      this.documentHtml = this.modifyAnchors(json.doc.documentHtml);

      this.logoUrl = json.logoUrl;
      this.colorBackground = json.venueStyle.colorBackground;
      this.colorFont = json.venueStyle.colorFont;

      this.isLoading = false;
    } catch (err) {
      console.error("Error loading", err);
      this.hasErrors = true;
      this.isLoading = false;
      return;
    }
  },
  methods: {
    modifyAnchors(html) {
      // Parse the HTML string into a document object
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Get all anchor elements
      const anchors = doc.querySelectorAll("a");

      // Modify the href of each anchor
      anchors.forEach((anchor) => {
        const url = new URL(anchor.href);
        url.searchParams.set("venueId", this.venueId);
        anchor.href = url.toString();
      });

      // Serialize the modified document back to a string
      const serializer = new XMLSerializer();
      return serializer.serializeToString(doc);
    },
  },
};
</script>

<style lang="scss">
</style>